<template>
    <v-select :items="combo" :value="value" @input="alteraValor" label="Responsável"/>
</template>
<script>
    import _ from 'lodash'

    export default {
        props: ['value'],
        data() {
            return {
                combo: []
            }
        },
        beforeMount() {
            const resultado = this.$store.state.orgaos
            this.combo = this.converterParaComboOrgao(resultado)
        },
        methods: {
            converterParaComboOrgao(orgaos) {
                let novoArray = []

                if (orgaos) {
                    for (const orgao of orgaos) {
                        novoArray.push({text: orgao.sigla, value: orgao.id})
                    }
                    novoArray = _.sortBy(novoArray, 'text')
                }

                return _.union([{text: 'Selecione', value: null}], novoArray)
            },
            alteraValor(event) {
                this.$emit('input', event)
            }
        }
    }
</script>